import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="dropdown"
export default class extends Controller {
  toggle(event) {
    const menu = event.currentTarget.parentNode.querySelector(".dropdown-menu");
    menu.classList.toggle("hidden");

    // Close all other dropdowns
    document.querySelectorAll(".dropdown-menu").forEach(function (el) {
      if (!el.isSameNode(menu)) {
        el.classList.add("hidden");
      }
    });
  }
}
